import { Trade } from '../../types/entities';

export interface TradesByStrategyId {
  loading: boolean;
  pending: boolean;
  loaded: boolean;
  error?: string;
  trades: Trade[];
}

export const initialTradeStateByLegId: TradesByStrategyId = {
  loading: false,
  pending: false,
  loaded: false,
  error: undefined,
  trades: []
};

export interface TradeState {
  [strategyId: string]: TradesByStrategyId;
}

export const initialTradeState: TradeState = {};
